/**
 * Management-agent middleware tags (client-safe)
 *
 * Authentication middleware for VPS-side management-agent callers.
 * The agent presents `Authorization: Bearer <gateway_token>` and the
 * server resolves the matching `agent_installations` row.
 *
 * @since 1.0.0
 */
import { RpcMiddleware } from "@effect/rpc";
import { Context } from "effect";

import { Unauthorized } from "../errors.ts";

/**
 * Caller context installed after a successful gateway-token verification.
 *
 * @since 1.0.0
 */
export class MgmtAgentInstallation extends Context.Tag("MgmtAgentInstallation")<
  MgmtAgentInstallation,
  {
    readonly installationId: string;
  }
>() {}

/**
 * RPC middleware tag guarding management-agent endpoints.
 *
 * Hard-scoped to `appendConfigLog` — never apply to user-facing RPCs.
 *
 * @since 1.0.0
 */
export class MgmtAgentMiddleware extends RpcMiddleware.Tag<MgmtAgentMiddleware>()(
  "MgmtAgentMiddleware",
  {
    provides: MgmtAgentInstallation,
    failure: Unauthorized,
    requiredForClient: true,
  },
) {}
